export default "__VITE_ASSET__CNe6Kkpn__"